module.exports = __webpack_public_path__ + "static/img/project02.56b4cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project02.png
// module id = XUPo
// module chunks = 1